import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { findActiveNavItem, type NavItem } from './app-nav';

export function useActiveNavItem(): NavItem | null {
  const { pathname } = useLocation();
  return useMemo(() => findActiveNavItem(pathname), [pathname]);
}
